import {ListItem} from "@domain/common/list-view/list-item";

/**
 * Types d'opérations log
 */
export enum TypeOpeLog {
    IMPORT = 'T',
    REINTEGRATION = 'R'
}

/**
 * DTO représentant un log d'opération carte
 */
export class OpeLog implements ListItem {
    idOpeLog: number;
    idParent: number;
    date: Date;
    typeOpeLog: TypeOpeLog;
    nbOpe: number;
    nbErreur: number;
    nbCorrect: number;
    nbRejet: number;
    nbExclue: number;
    idRacine: number;
    isLastOpe: boolean;

    isDisplayed?: boolean;
    isSelected?: boolean;
    isOpened?: boolean;

    getKey(): number {
        return this.idOpeLog;
    }
}